<template>
  <v-menu v-model="open" offset-y top nudge-top="8" min-width="320" max-width="360" content-class="tracey-agent-select__menu">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        small
        class="tracey-agent-select__activator"
        v-bind="attrs"
        v-on="on"
      >
        {{ current.name }}
        <v-icon small class="tracey-agent-select__chevron" :class="{ 'tracey-agent-select__chevron--open': open }">
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>

    <div class="tracey-agent-select__list">
      <button
        v-for="agent in agents"
        :key="agent.key"
        type="button"
        class="tracey-agent-select__item"
        :class="{ 'tracey-agent-select__item--active': agent.key === value }"
        @click="select(agent.key)"
      >
        <div class="tracey-agent-select__item-head">
          <span class="tracey-agent-select__item-name">{{ agent.name }}</span>
          <v-icon v-if="agent.key === value" small color="primary">mdi-check</v-icon>
        </div>
        <p class="tracey-agent-select__item-desc">{{ agent.description }}</p>
      </button>
    </div>
  </v-menu>
</template>

<script>
import { TRACEY_AGENTS, agentByKey } from '../agentVersions.js';

export default {
  name: 'TraceyAgentSelect',
  props: {
    value: { type: String, default: 'ultra' },
  },
  data() {
    return { open: false, agents: TRACEY_AGENTS };
  },
  computed: {
    current() {
      return agentByKey(this.value);
    },
  },
  methods: {
    select(key) {
      this.open = false;
      if (key !== this.value) this.$emit('input', key);
    },
  },
};
</script>

<style scoped>
.tracey-agent-select__activator {
  text-transform: none;
  letter-spacing: 0;
  color: #6e6e80 !important;
  font-weight: 600;
}

.tracey-agent-select__chevron {
  margin-left: 2px;
  transition: transform 0.15s ease;
}

.tracey-agent-select__chevron--open {
  transform: rotate(180deg);
}
</style>

<style>
/* Not scoped: v-menu teleports its content outside this component's DOM
   subtree, so a scoped selector would never match it. */
.tracey-agent-select__menu {
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
}

.tracey-agent-select__list {
  background: #fff;
  padding: 6px;
}

.tracey-agent-select__item {
  display: block;
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  font-family: inherit;
}

.tracey-agent-select__item:hover {
  background: #f7f7f8;
}

.tracey-agent-select__item--active {
  background: #f2f4ff;
}

.tracey-agent-select__item-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.tracey-agent-select__item-name {
  font-size: 14px;
  font-weight: 600;
  color: #0d0d0d;
}

.tracey-agent-select__item-desc {
  margin: 4px 0 0;
  font-size: 12.5px;
  line-height: 1.45;
  color: #6e6e80;
}
</style>
